// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import BookDonationManager from "../../components/dashboard/BookDonationManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <BookDonationManager />
    </DashboardLayout>
  );
}
